export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-950">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-background-50 mb-3">APP下载</h2>
            <p className="text-sm md:text-base text-background-50/70 mb-6 leading-relaxed max-w-md mx-auto lg:mx-0">
              下载汗汗漫画APP，随时随地畅享下拉式连续阅读体验。
              离线缓存、夜间模式、阅读记录同步，手机看漫画更便捷。
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-background-50 text-foreground-950 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors"
              >
                <i className="ri-android-line text-lg"></i>
                Android 下载
              </a>
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full border border-background-50/30 text-background-50 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-background-50/10 transition-colors"
              >
                <i className="ri-apple-line text-lg"></i>
                iOS 下载
              </a>
            </div>
            <p className="text-xs text-background-50/40 mt-4">支持 Android 8.0+ / iOS 14.0+</p>
          </div>

          <div className="flex-shrink-0">
            <div className="relative">
              <div className="w-48 h-80 md:w-56 md:h-96 rounded-2xl overflow-hidden border-2 border-background-50/20">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20a%20colorful%20manga%20reading%20app%20interface%20with%20beautiful%20comic%20artwork%20on%20screen%2C%20clean%20minimal%20UI%20design%20with%20warm%20coral%20accents%2C%20showing%20vertical%20scroll%20webtoon%20reading%20mode%2C%20soft%20phone%20case%20with%20gentle%20shadows%2C%20professional%20product%20photography%20style%20on%20clean%20background&width=500&height=900&seq=app-mockup-manga&orientation=portrait"
                  alt="汗汗漫画APP界面"
                  title="汗汗漫画APP移动端阅读"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -top-3 -right-3 w-14 h-14 rounded-full bg-primary-500 flex items-center justify-center">
                <span className="text-background-50 font-heading text-xs">NEW</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}